import BaseScene from "../../scenes/BaseScene";

export default class AnimatedFeedback extends Phaser.GameObjects.Container {
  // a container is much like a html element, it has a parent (possible the scene or game world), and can have childen added via this.add
  scene: BaseScene;
  goodbatteryImage: Phaser.GameObjects.Image;
  badbatteryImage: Phaser.GameObjects.Image;
  feedbackString: Phaser.GameObjects.Text;
  bg: Phaser.GameObjects.Graphics;
  isCorrect: boolean;
  constructor(scene: BaseScene) {
    // super to creat the container at the specified co-ordinates.
    super(scene, 0, 0);

    // !important - as we are using the 'new' keyword (and not using the scene
    // factory methods, `scene.add` ) we need to add it to the scene manually
    scene.add.existing(this);
    this.scene = scene;

    const bg = scene.add.graphics();
    this.add(bg);
    bg.fillStyle(0x000000, 0.9);
    bg.fillRect(
      0,
      0,
      this.scene.cameras.main.width,
      this.scene.cameras.main.height
    );

    
    this.bg = this.scene.add.graphics({
      x: this.scene.cameras.main.centerX,
      y: this.scene.cameras.main.centerY - 100
    })

    this.add(this.bg)

    this.feedbackString = this.scene.add
      .text(
        this.scene.cameras.main.centerX,
        this.scene.cameras.main.centerY + 160,
        "",
        this.scene.sponge.data.model.fonts.button
      )
      .setOrigin(0.5, 0)
      .setFontSize(60)
      .setWordWrapWidth(500)
      .setAlign("center");
    this.add(this.feedbackString);

    

    this.goodbatteryImage = this.scene.add.image(
      this.scene.cameras.main.centerX,
      this.scene.cameras.main.centerY - 100,
     "fullBattery"
    ).setAngle(-60).setAlpha(0);

    this.badbatteryImage = this.scene.add.image(
      this.scene.cameras.main.centerX,
      this.scene.cameras.main.centerY - 100,
     "loseBattery"
    ).setAngle(-60).setAlpha(0);

    this.add([this.goodbatteryImage,this.badbatteryImage]);

    
    
  }

  createDisplay(isCorrect: boolean){
    this.isCorrect = isCorrect;
    const colChoice: number = this.isCorrect?0x67cfc9 : 0xff00ff
    this.bg.clear()
    this.bg.lineStyle(9,this.isCorrect?0x67cfc9 : 0xff00ff, 1)
    this.bg.strokeCircle(0,0,180)
    this.bg.fillGradientStyle(colChoice,colChoice,0x000000,0x000000,0.5);
    this.bg.fillRect(-this.scene.cameras.main.width/2,-this.scene.cameras.main.height/2,this.scene.cameras.main.width,this.scene.cameras.main.height)

    this.goodbatteryImage.setAlpha(isCorrect ? 1:0);
    this.badbatteryImage.setAlpha(!isCorrect ? 1:0).setFrame(0);

    const fb =
      this.isCorrect
        ? this.scene.sponge.data.content.strings.positiveFeedback
        : this.scene.sponge.data.content.strings.negativeFeedback;
    this.feedbackString.setText(fb);

    this.showAnimation();

  }

  showAnimation(){

    if(this.isCorrect){
      this.scene.tweens.add({
        targets: this.goodbatteryImage,
        scale: 1.2,
        duration: 500,
        ease: "Quad.easeOut",
        yoyo: true,
        repeat: 3
      })

    }else{
      let frameNum = 0;
      this.scene.tweens.add({
        targets: this.badbatteryImage,
        scale: 1.2,
        duration: 500,
        ease: "Quad.easeOut",
        yoyo: true,
        repeat: 3,
        onRepeat:()=>{
          
          if(frameNum < 2){frameNum++}
          this.badbatteryImage.setFrame(frameNum)
        }
      })
      
    }

    for(let i: number = 0; i < 4; i ++){
      const bg = this.scene.add.graphics({
        x: this.scene.cameras.main.centerX,
        y: this.scene.cameras.main.centerY - 100
      })
  
      bg.lineStyle(9,this.isCorrect?0x67cfc9 : 0xff00ff, 1)
      bg.strokeCircle(0,0,180)
      this.add(bg)

      this.scene.tweens.add({
        targets: bg,
        alpha: 0,
        scale: 2,
        duration: 1000,
        ease: "Quad.easeOut",
        delay: 1000 * i,
        onComplete: ()=>{bg.destroy();}
      })
    }

    this.scene.time.addEvent({
      delay:5000,
      callbackScope:this,
      callback: this.removeDisplay
    })


  }

  removeDisplay(){
    this.goodbatteryImage.setAlpha(0);
    this.badbatteryImage.setAlpha(0);
    this.feedbackString.setText("");
    this.bg.clear();
    this.emit("animatedFeedbackComplete",this.isCorrect)
  }

  update(): void {
    // const delta = this.scene.time.
  }
}
